<template>
  <div class="box">
    <vue-loading v-if="loading" :active.sync="loading" :is-full-page="true" loader="dots" color="#70A1F0"></vue-loading>
    <div class="resources">
      <div class="report">
        <vue-good-table
          :columns="columns[resource]"
          :rows="report[resource]"
          :search-options="{
            enabled: true,
            skipDiacritics: true,
            placeholder: 'filter'
          }"
          :pagination-options="{
            enabled: true,
            perPage: 50,
          }"
          @on-row-click="selectResource"
          styleClass="vgt-table condensed">
          <template slot="table-row" slot-scope="props">
            <span class="wrap">
              <span :class="getCellClass(props.row.originalIndex)">
                {{props.formattedRow[props.column.field]}}
              </span>
            </span>
          </template>
        </vue-good-table>
      </div>
      <transition>
        <div class="panel">
          <div class="heading">

            <h4>Resources</h4>
          </div>

          <div class="btn-group dropdown">
            <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              {{ resource }}
            </button>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
              <button v-for="resourceType in resourceTypes" :key="resourceType" class="dropdown-item" type="button" v-on:click="setProperty(resourceType)">{{ resourceType }}</button>
            </div>

            <div class="resources-download">
              <button type="button" class="btn btn-sm btn-primary" v-on:click="downloadCSV()">Download Report</button>
            </div>
          </div>

          <div v-if="selectedResource !== null">

            <ResourceDetails :resource="resource" :report="report" :selectedResource="selectedResource" :columns="columns" :supportedColumns="supportedColumns" v-on:addCol='addCol' v-on:remCol='remCol'/>

          </div>

        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import HTTP from '@/common/http'
import { mapGetters } from 'vuex'
import VueLoading from 'vue-loading-overlay'
import ResourceDetails from '@/components/Resources/Details'
import ResoucesData from '@/components/Resources/data.json'

export default {
  components: {
    VueLoading,
    ResourceDetails
  },
  props: [
    'id',
    'resource'
  ],
  computed: {
    ...mapGetters([
      'activeType'
    ])
  },
  created: function () {
    this.getData()
  },
  methods: {
    getData: function () {
      this.selectedResource = null
      if (this.report[this.resource]) {
        // Report for this resource type has already been loaded
        if (this.report[this.resource].length > 0) {
          // Report for this resource type includes at least 1 resource, select the first resource
          this.selectedResource = 0
        }
      } else {
        // Load report for this resource type
        this.loading = true
        HTTP.get(`resources/${this.activeType}/${this.id}/${this.resource}`)
          .then((response) => {
            this.report[this.resource] = response.data.resources
            if (this.report[this.resource].length > 0) {
              // Report for this resource type includes at least 1 resource, select the first resource
              this.selectedResource = 0
            }
          })
          .catch((error) => {
            this.flashMessage.error({
              message: `Failed to get Resources Summary: ${error.message}`
            })
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    setProperty: function (resourceType) {
      // Clear table sorting before updating table
      this.$children[0].sorts = []
      // Update route with new resource selection
      this.$router.push({ name: this.$router.$route, params: {resource: resourceType} }).catch(() => {})
    },
    selectResource: function (params) {
      this.selectedResource = params.row.originalIndex
    },
    getCellClass: function (index) {
      return index === this.selectedResource ? 'selected-resource' : ''
    },
    addCol: function (col) {
      this.columns[this.resource] = this.columns[this.resource].filter(function (el) { return el.label !== col.label })
      this.columns[this.resource].push(col)
    },
    remCol: function (col) {
      this.$children[0].sorts = []
      this.columns[this.resource] = this.columns[this.resource].filter(function (el) { return el.label !== col.label })
    },
    downloadCSV: function () {
      this.flashMessage.info({
        message: `Generating resources ${this.resource} CSV report`,
        time: 3000
      })
      HTTP.get(`resources/${this.activeType}/${this.id}/${this.resource}/csv`)
        .then((response) => {
          window.location = response.data.signedUrl
          this.flashMessage.success({
            message: `Resources ${this.resource} CSV report generation complete`
          })
        })
        .catch((error) => {
          this.flashMessage.error({
            message: `Failed to generate resources ${this.resource} CSV report : ${error.message}`
          })
        })
    }
  },
  data () {
    return {
      loading: false,
      resourceTypes: ['lambda', 'ec2', 's3', 'rds', 'rdscluster', 'eip'],
      selectedResource: null,
      report: {},
      columns: ResoucesData.defaultColumns,
      supportedColumns: ResoucesData.supportedColumns
    }
  },
  watch: {
    id: function () {
      this.report = {}
      this.getData()
    },
    resource: function () {
      this.getData()
    }
  }
}
</script>

<style scoped>

.resources {
  display: flex;
}
.panel {
  padding: 20px;
  display: inline-block;
  position: relative;
  width: 25%;
  border: 1px solid #dcdfe6;
  margin: 20px;
}
.report {
  padding: 20px;
  padding-right: 0px;
  display: inline-block;
  position: relative;
  width: 75%;
}
/deep/ .vgt-left-align {
    font-size: 13px;
  }
/deep/ .vgt-right-align {
  font-size: 13px;
}
.selected-resource {
  font-weight: 800;
}
.heading {
  display: inline-block;
  position: relative;
}
.dropdown {
  float: right;
  position: relative;
}
.details {
  font-size: 12px;
}
.detail {
  padding-top: 10px;
}
.detail h6 {
  padding-top: 18px;
}
.tags {
  padding-left: 0px;
}
.tag {
  padding-top: 10px;
  font-size: 12px;
}
.resources-download {
  top: 0px;
  right: 100px;
  position: absolute;
  cursor: pointer;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/views/Resources.vue